import { httpClient } from '@/services/http/httpClient'

type AssignResponsibleToIdeaStepParams = {
  ideaId: string
  taskId: string
  responsibleId: string | null
}

export async function assignResponsibleToIdeaStep({
  ideaId,
  taskId,
  responsibleId,
}: AssignResponsibleToIdeaStepParams): Promise<void> {
  await httpClient.put(`/ideas/funnel/steps/${taskId}/assign-responsible`, {
    ideaId,
    responsibleId,
  })
}
